<template>
  <div id="gg">
    <header class="am-topbar">
      <OffCanvas class="meun">边侧栏</OffCanvas>
      <div class="logo-wrapper">
        <div class="title">公告</div>
      </div>
    </header>
    <div class="tab">
      <router-link :to="{ name: 'gg', params: { nr: 'gsgg' }}">公司公告</router-link>
      <router-link :to="{ name: 'gg', params: { nr: 'jys' }}">交易所公告</router-link>
      <router-link :to="{ name: 'gg', params: { nr: 'bzj' }}">保证金公告</router-link>
    </div>
    <List v-show="$route.params.nr=='gsgg'" :list="gsgg" name="gsgg"></List>
    <List v-show="$route.params.nr=='jys'" :list="jys" name="jys"></List>
    <List v-show="$route.params.nr=='bzj'" :list="bzj" name="bzj"></List>
    <ICP></ICP>
  </div>
</template>

<script>
  import OffCanvas from '@/components/OffCanvas/OffCanvas'
  import ICP from '@/components/ICP/ICP'
  import List from '@/components/list/List'
  import ajax from '@/common/ajax/ajax'

  export default {
    name: 'gg',
    data () {
      return {
        gsgg: [],
        jys: [],
        bzj: []
      }
    },
    created: function () {
      ajax.getGsgglist().then(
        data => {
          this.gsgg = data
        }
      )
      ajax.getJyslist().then(
        data => {
          this.jys = data
        }
      )
      ajax.getBzjlist().then(
        data => {
          this.bzj = data
          this.bzj.forEach(function (value) {
            value.title = value.title.replace('-', '年').replace('-', '月') + '日保证金调整公告'
          })
        }
      )
    },
    components: {
      OffCanvas,
      ICP,
      List
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" rel="stylesheet/stylus">
  @import "../../common/stylus/common.styl"
  #gg
    .tab
      padding 0 $bj 0 $bj
      background-color $color2
      font-size $font_size2
      color $font_color3
      height 40px
      line-height 40px
      a
        margin 0 16px 0 0
        &:after
          content ' '
          width 0
          height 5px
          left 50%
          top 25px
          position absolute
        &.router-link-active
          color $font_color2
          position relative
          &:after
            background-color $color1
            width 100%
            left 0
            transition left, width 0.5s, 0.5s

</style>



// WEBPACK FOOTER //
// gg.vue?05f60a4e